import { createContext } from 'react';
import EditMPPointConfigContext from 'types/contexts/EditMPPointConfigContext';

export default createContext({} as EditMPPointConfigContext);
